import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';

import LoaderComponent from '@components/LoaderComponent';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { createTagForSelectedProducts, removeProductTagIds } from '@services/collectionService';

import { getQueryParamsFromArray } from '@utils/helper';

const TagUpdateModal = ({
	title,
	allTagList,
	commonTags,
	onCancel,
	updateTagList,
	fetchAllTags,
	isFavouriteProduct = false,
	favouriteProductIdList
}) => {
	const [activeColorCode, setActiveColorCode] = useState('#DBFFE5');
	const dispatch = useDispatch();
	const selectedProductIds = useSelector((store) => store.product.selectedProductIds);
	const [text, setText] = useState('');

	useEffect(() => {
		(async () => {
			await fetchAllTags(text);
		})();
	}, [text]);

	const removeTag = async (id) => {
		let params = '';
		if (isFavouriteProduct) {
			params += `?productIdList=${getQueryParamsFromArray(favouriteProductIdList)}`;
		} else {
			params += `?productIdList=${getQueryParamsFromArray(selectedProductIds)}`;
		}
		try {
			dispatch(openLoader());
			const data = await removeProductTagIds(params, id);
			updateTagList(data);
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const renderUnusedTags = () => {
		let usedTagIds = commonTags?.map((item) => item.id);
		if (usedTagIds) {
			return allTagList?.filter((item) => !usedTagIds.includes(item.id));
		} else {
			return allTagList;
		}
	};

	const createTag = async (id) => {
		try {
			dispatch(openLoader());
			let postData = { text, colorCode: activeColorCode };
			if (id) {
				postData['id'] = id;
			}
			let requestBody = {};
			if (isFavouriteProduct) {
				requestBody = {
					productIdList: favouriteProductIdList,
					tagRequest: postData
				};
			} else {
				requestBody = {
					productIdList: selectedProductIds,
					tagRequest: postData
				};
			}

			const data = await createTagForSelectedProducts(requestBody);
			updateTagList(data);
			setText('');
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const toggleActiveColor = (code) => {
		setActiveColorCode(code);
	};

	const isActiveColor = (code) => (activeColorCode === code ? 'single-color active' : 'single-color');

	const renderExistingTags = () => {
		return commonTags?.map((item, index) => {
			return (
				<span className="status radius" key={`tag_${index}`} style={{ background: item.colorCode }}>
					{item.text}{' '}
					<img
						onClick={() => removeTag(item.id)}
						src={`${process.env.PUBLIC_URL}/icons/chip-close.svg`}
						className="ml-1 cursor-pointer"
					/>
				</span>
			);
		});
	};

	const renderAllTags = () => {
		return renderUnusedTags(allTagList)?.map((item, index) => {
			return (
				<p
					className="px-3 py-1 d-flex align-items-center cursor-pointer"
					key={`all_tags_${index}`}
					onClick={() => createTag(item.id)}
				>
					<span className="status radius cursor-pointer" style={{ background: item.colorCode }}>
						{item.text}
					</span>
				</p>
			);
		});
	};

	const createAbleTags = () => {
		if (renderUnusedTags(allTagList)?.length === 0) {
			return (
				<div className="create">
					<p className="px-3 py-1 d-flex align-items-center" onClick={() => createTag()}>
						<span className="semibold-14">Create</span>
						<span className="status radius ml-2" style={{ background: activeColorCode }}>
							{text}
						</span>
					</p>
					<div className="colors">
						<span
							className={`single-color ${isActiveColor('#DBFFE5')}`}
							onClick={() => toggleActiveColor('#DBFFE5')}
							style={{ background: '#DBFFE5' }}
						/>
						<span
							className={isActiveColor('#FFEAEA')}
							onClick={() => toggleActiveColor('#FFEAEA')}
							style={{ background: '#FFEAEA' }}
						/>
						<span
							className={isActiveColor('#FBD9C2')}
							onClick={() => toggleActiveColor('#FBD9C2')}
							style={{ background: '#FBD9C2' }}
						/>
						<span
							className={isActiveColor('#FEEAC1')}
							onClick={() => toggleActiveColor('#FEEAC1')}
							style={{ background: '#FEEAC1' }}
						/>
						<span
							className={isActiveColor('#DFF2FF')}
							onClick={() => toggleActiveColor('#DFF2FF')}
							style={{ background: '#DFF2FF' }}
						/>
						<span
							className={isActiveColor('#EDE3FE')}
							onClick={() => toggleActiveColor('#EDE3FE')}
							style={{ background: '#EDE3FE' }}
						/>
						<span
							className={isActiveColor('#D0F0FD')}
							onClick={() => toggleActiveColor('#D0F0FD')}
							style={{ background: '#D0F0FD' }}
						/>
						<span
							className={isActiveColor('#F4DBE6')}
							onClick={() => toggleActiveColor('#F4DBE6')}
							style={{ background: '#F4DBE6' }}
						/>
						<span
							className={isActiveColor('#C2F5E9')}
							onClick={() => toggleActiveColor('#C2F5E9')}
							style={{ background: '#C2F5E9' }}
						/>
						<span
							className={isActiveColor('#EDDBD5')}
							onClick={() => toggleActiveColor('#EDDBD5')}
							style={{ background: '#EDDBD5' }}
						/>
					</div>
				</div>
			);
		}
	};

	return (
		<>
			<Modal
				show={true}
				centered
				animation={true}
				backdrop="static"
				onHide={onCancel}
				className="auto-width-popup upload-tag-popup"
			>
				<LoaderComponent className="">
					<div className="common-popup upload-design-popup shadow-24dp">
						<Modal.Header closeButton>
							<h3 className="semibold-16 mb-0">{title}</h3>
						</Modal.Header>
						<Modal.Body>
							<div className="common-popup-body">
								<div className="container px-0">
									<div className="row">
										<div className="col-md-12 mb-2">
											<div className="select-tag-dropdown w-100 position-static shadow-none">
												<div className="py-2">
													<div className="selected-tags design-tags mb-2">
														{renderExistingTags()}
													</div>
													<div className="input-tag">
														<input
															type="text"
															autoComplete="off"
															placeholder="Select or create new"
															value={text}
															onChange={(e) => setText(e.target.value)}
															onKeyDown={(event) => {
																if (event.key === 'Enter') {
																	createTag();
																}
															}}
														/>
														<img
															src={`${process.env.PUBLIC_URL}/images/chevron_down.svg`}
														/>
													</div>
												</div>
												{createAbleTags()}
												<div className="suggested-tags scroll-y-label mt-1">
													{renderAllTags()}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</Modal.Body>
						<div className="modal-footer align-items-center justify-content-end">
							<div className="footer-buttons text-right">
								<button onClick={onCancel} className="button tertiary size32 ml-2">
									Submit
								</button>
							</div>
						</div>
					</div>
				</LoaderComponent>
			</Modal>
		</>
	);
};

export default TagUpdateModal;
